module.exports = __webpack_public_path__ + "assets/img/international-alibaba-payment-info-tip.38829561.svg";